import { useEffect, useState } from "react";
import { useMaterialUIController } from "context";

import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "monitor/LayoutContainers/DashboardLayout";
import DashboardNavbar from "monitor/Navbars/DashboardNavbar";
import Footer from "monitor/Footer";
import DataTable from "monitor/Tables/DataTable";
import Icon from "@mui/material/Icon";
import { mapDataToRows } from "layouts/liveness/data/livenessTableData";
import { useNavigate } from "react-router-dom";
import config from "config";
import "flatpickr/dist/themes/dark.css";
import Collapse from "@mui/material/Collapse"
import { Dialog, DialogTitle, DialogContent, DialogActions, Menu, Tooltip } from "@mui/material"
import { showToast } from "utils/swalToast"
import { sanitizeFileName, FILE_NAME_HELP_TEXT } from "utils/fileName"

import Flatpickr from "react-flatpickr";
import "flatpickr/dist/l10n/es.js";
import MDButton from "components/MDButton";

//jwt decode para verificacion
import { jwtDecode } from "jwt-decode";
import {
  Card,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { flushSync } from "react-dom"

const PAGE_SIZE = 10;

const reindexRows = (rows) =>
  rows.map((row, index) => ({ ...row, item: index + 1 }));

const mergeUniqueRows = (prevRows, incomingRows) => {
  const existingIds = new Set(prevRows.map((row) => row.id).filter((id) => id != null));
  const uniqueIncoming = incomingRows.filter((row) => row.id == null || !existingIds.has(row.id));
  return reindexRows([...prevRows, ...uniqueIncoming]);
};

function Liveness() {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const token = (sessionStorage.getItem("token") || localStorage.getItem("token"));
  const [nombreTerm, setNombreTerm] = useState(""); // State to manage the search term
  const [docNro, setDocNro] = useState(""); // State to manage the search term
  const [ipEquipo, setIpEquipo] = useState("");
  const [fechaDesde, setFechaDesde] = useState(() => {
    const d = new Date();
    d.setDate(1);
    d.setHours(0, 0, 0, 0);
    return d;
  });
  const [fechaHasta, setFechaHastaTerm] = useState(() => {
    const d = new Date();
    d.setHours(23, 59, 59, 999);
    return d;
  });
  const [nextPage, setNextPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [hasMore, setHasMore] = useState(false);
  const [isLoadingData, setIsLoadingData] = useState(false);
  const [empresas, setEmpresas] = useState([]);
  const [sucursales, setSucursales] = useState([]);
  const [eventos, setEventos] = useState([]);
  const [zonas, setZonas] = useState([]);
  const [selectedEmpresas, setSelectedEmpresas] = useState("");
  const [selectedSucursales, setSelectedSucursales] = useState("");
  const [selectedEventos, setSelectedEventos] = useState("");
  const [selectedZonas, setSelectedZonas] = useState("");
  const [selectedTipoDoc, setSelectedTipoDoc] = useState("");
  const [nombreDispositivo, setNombreDispositivo] = useState("");
  const [authChecked, setAuthChecked] = useState(false);
  const [rows, setRows] = useState([]);
  const [noIdentificados, setNoIdentificados] = useState(null)
  const [duplicados, setDuplicados] = useState(null)
  const navigate = useNavigate();
  const [multiplesCoincidencias, setMultiplesCoincidencias] = useState(null)
  const dialogStyle = {
    backgroundColor: darkMode ? "#1a2035" : "#ffffff",
    color: darkMode ? "#ffffff" : "#1a2035",
  };
  const columns = [
    { Header: "Item", accessor: "item", width: "5%", align: "center" },
    { Header: "Persona", accessor: "person", width: "30%", align: "left" },
    { Header: "Empresa/Sucursal", accessor: "sucursal", width: "10%", align: "center" },
    { Header: "Evento", accessor: "evento", width: "10%", align: "center" },
    { Header: "Dispositivo", accessor: "device", width: "10%", align: "center" },
    { Header: "Fecha-Hora", accessor: "dateTime", width: "20%", align: "center" },
  ];

  const [filtersOpen, setFiltersOpen] = useState(() => {
    const saved = sessionStorage.getItem("livenessFiltersOpen")
    return saved ? JSON.parse(saved) : false
  })
  useEffect(() => {
    sessionStorage.setItem("livenessFiltersOpen", JSON.stringify(filtersOpen))
  }, [filtersOpen])
  const toggleFilters = () => setFiltersOpen((o) => !o)

  const [exportFormat, setExportFormat] = useState("XLSX")
  const [isDownloading, setIsDownloading] = useState(false)
  const [nameDialogOpen, setNameDialogOpen] = useState(false)
  const [pendingFormat, setPendingFormat] = useState("XLSX")
  const [fileName, setFileName] = useState("")
  const [downloadAnchorEl, setDownloadAnchorEl] = useState(null)
  const downloadMenuOpen = Boolean(downloadAnchorEl)
  const openDownloadMenu = (e) => setDownloadAnchorEl(e.currentTarget)
  const closeDownloadMenu = () => setDownloadAnchorEl(null)

  useEffect(() => {
    if (!token) {
      navigate("/authentication/sign-in", { replace: true });
      return;
    }
    try {
      const { exp } = jwtDecode(token);
      const now = Math.floor(Date.now() / 1000);
      if (!exp || exp < now) {
        navigate("/authentication/sign-in", { replace: true });
        return;
      }
      setAuthChecked(true);
    } catch {
      navigate("/authentication/sign-in", { replace: true });
    }
  }, [token, navigate]);

  const formatDate = (date) => {
    if (!date) return ""
    const pad = (n) => (n < 10 ? "0" + n : n)
    return (
      date.getFullYear() +
      "-" +
      pad(date.getMonth() + 1) +
      "-" +
      pad(date.getDate()) +
      " " +
      pad(date.getHours()) +
      ":" +
      pad(date.getMinutes()) +
      ":" +
      pad(date.getSeconds())
    )
  }

  const openNameDialog = (format) => {
    setPendingFormat(format)
    setExportFormat(format)
    setFileName("")
    setNameDialogOpen(true)
  }
  const closeNameDialog = () => setNameDialogOpen(false)
  const confirmDownload = async () => {
    setNameDialogOpen(false)
    await handleDownload(pendingFormat, fileName)
  }
  const handleDownload = async (format = exportFormat, nombre = "") => {
    setIsDownloading(true)
    closeDownloadMenu()
    let apiUrl = `${config.api.baseURL}/event/liveness/export2/${format}?`

    if (selectedEmpresas) apiUrl += `empresaId=${encodeURIComponent(selectedEmpresas)}&`
    if (selectedSucursales) apiUrl += `sucursalId=${encodeURIComponent(selectedSucursales)}&`
    if (selectedEventos) apiUrl += `eventoId=${encodeURIComponent(selectedEventos)}&`
    if (selectedZonas) apiUrl += `zonaId=${encodeURIComponent(selectedZonas)}&`
    if (nombreTerm) apiUrl += `nombre=${encodeURIComponent(nombreTerm)}&`
    if (selectedTipoDoc) apiUrl += `tipoDoc=${encodeURIComponent(selectedTipoDoc)}&`
    if (docNro) apiUrl += `document_number=${encodeURIComponent(docNro)}&`
    if (ipEquipo) apiUrl += `ipDevice=${encodeURIComponent(ipEquipo)}&`
    if (fechaDesde) apiUrl += `fechaDesde=${encodeURIComponent(formatDate(fechaDesde))}&`
    if (fechaHasta) apiUrl += `fechaHasta=${encodeURIComponent(formatDate(fechaHasta))}&`
    if (nombreDispositivo) apiUrl += `nombreDispositivo=${encodeURIComponent(nombreDispositivo)}&`
    if (nombre && nombre.trim()) apiUrl += `nombreArchivo=${encodeURIComponent(nombre.trim())}&`
    if (noIdentificados !== null && noIdentificados !== "") apiUrl += `noIdentificados=${encodeURIComponent(noIdentificados)}&`
    if (duplicados !== null && duplicados !== "") apiUrl += `duplicados=${encodeURIComponent(duplicados)}&`
    if (multiplesCoincidencias !== null && multiplesCoincidencias !== "") apiUrl += `multiplesCoincidencias=${encodeURIComponent(multiplesCoincidencias)}&`
    if (totalPages !== null) apiUrl += `total=${encodeURIComponent(Math.ceil(totalPages * PAGE_SIZE / 100000))}&`

    try {
      const res = await fetch(apiUrl, { method: "GET", headers: { Authorization: `Bearer ${token}` } })
      if (!res.ok) throw new Error("Error al descargar el archivo.")
      const data = await res.json()
      showToast({ icon: "info", title: "Mensaje", text: data.mensaje || "Solicitud de exportación recibida." })
    } catch (error) {
      console.error("Error al descargar el archivo:", error)
    } finally {
      setIsDownloading(false)
    }
  }

  useEffect(() => {
    if (!authChecked) return;
    const bootstrap = async () => {
      try {
        setIsLoadingData(true)
        await getEmpresas()
        await fetchPageData(0, { append: false })
      } finally {
        setIsLoadingData(false)
      }
    }
    bootstrap()
  }, [authChecked]);

  const resetValues = () => {
    setNombreTerm("");
    setDocNro("");
    setIpEquipo("");
    setFechaDesde(null);
    setFechaHastaTerm(null);
    setSelectedEmpresas("");
    setSelectedSucursales("");
    setSelectedEventos("");
    setSelectedZonas("");
    setNombreDispositivo("");
    setSelectedTipoDoc("");
    setNoIdentificados(null)
    setDuplicados(null)
    setMultiplesCoincidencias(null)
  };

  const handleClearFilters = async () => {
    try {
      setIsLoadingData(true)
      flushSync(() => {
        resetValues()
      })
      setNextPage(0)
      await fetchPageData(0, { append: false })
    } finally {
      setIsLoadingData(false)
    }
  };

  const handleSearch = async () => {
    try {
      setIsLoadingData(true)
      setNextPage(0)
      await fetchPageData(0, { append: false })
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoadingData(false)
    }
  };

  const fetchPageData = async (page, { append = false } = {}) => {
    try {
      let apiUrl = `${config.api.baseURL}/event/liveness?page=${page}&size=${PAGE_SIZE}&`

      if (selectedEmpresas) apiUrl += `empresaId=${encodeURIComponent(selectedEmpresas)}&`
      if (selectedSucursales) apiUrl += `sucursalId=${encodeURIComponent(selectedSucursales)}&`
      if (selectedEventos) apiUrl += `eventoId=${encodeURIComponent(selectedEventos)}&`
      if (selectedZonas) apiUrl += `zonaId=${encodeURIComponent(selectedZonas)}&`
      if (nombreTerm) apiUrl += `nombre=${encodeURIComponent(nombreTerm)}&`
      if (selectedTipoDoc) apiUrl += `tipoDoc=${encodeURIComponent(selectedTipoDoc)}&`
      if (docNro) apiUrl += `document_number=${encodeURIComponent(docNro)}&`
      if (ipEquipo) apiUrl += `ipDevice=${encodeURIComponent(ipEquipo)}&`
      if (fechaDesde) apiUrl += `fechaDesde=${encodeURIComponent(formatDate(fechaDesde))}&`
      if (fechaHasta) apiUrl += `fechaHasta=${encodeURIComponent(formatDate(fechaHasta))}&`
      if (nombreDispositivo) apiUrl += `nombreDispositivo=${encodeURIComponent(nombreDispositivo)}&`
      if (noIdentificados !== null && noIdentificados !== "") apiUrl += `noIdentificados=${encodeURIComponent(noIdentificados)}&`
      if (duplicados !== null && duplicados !== "") apiUrl += `duplicados=${encodeURIComponent(duplicados)}&`
      if (multiplesCoincidencias !== null && multiplesCoincidencias !== "") apiUrl += `multiplesCoincidencias=${encodeURIComponent(multiplesCoincidencias)}&`

      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200) {
        const result = await response.json();
        const totalPagesFromApi = result?.page?.totalPages ?? 0
        const totalElementsFromApi = result?.page?.totalElements ?? totalPagesFromApi * PAGE_SIZE
        const incomingRows = result?._embedded
          ? mapDataToRows(
              result._embedded.livenessEventList ||
              Object.values(result._embedded)[0] ||
              [],
              config,
              page
            )
          : []

        setTotalPages(totalPagesFromApi)
        setTotalCount(totalElementsFromApi)
        setHasMore(page + 1 < totalPagesFromApi)
        setNextPage(page + 1)

        if (append) {
          setRows((prevRows) => mergeUniqueRows(prevRows, incomingRows))
        } else {
          setRows(reindexRows(incomingRows))
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleLoadMore = async () => {
    if (isLoadingData || !hasMore) return
    try {
      setIsLoadingData(true)
      await fetchPageData(nextPage, { append: true })
    } finally {
      setIsLoadingData(false)
    }
  };

  const handleNombreSearch = (event) => {
    const term = event.target.value;
    setNombreTerm(term);
  };

  const handleNombreDispositivoSearch = (event) => {
    const term = event.target.value;
    setNombreDispositivo(term);
  };

  const handleNroDocSearch = (event) => {
    const term = event.target.value;
    setDocNro(term);
  };

  const handleIpEquipoSearch = (event) => {
    const term = event.target.value;
    setIpEquipo(term);
  };

  const getEmpresas = async () => {
    try {
      let empUrl = `${config.api.baseURL}/empresas`;
      const response = await fetch(empUrl, {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.status === 200) {
        const result = await response.json();
        if (result) {
          setEmpresas(result);
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchSucursales = async (selectedId) => {
    try {
      if (selectedId) {
        let sucuUrl = `${config.api.baseURL}/sucursales/empresa/${selectedId}`;
        const response = await fetch(sucuUrl, {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.status === 200) {
          const result = await response.json();
          setSelectedSucursales("");
          if (result) {
            setSucursales(result);
          }
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchZonas = async (selectedId) => {
    try {
      if (selectedId) {
        let zonaUrl = `${config.api.baseURL}/zonas/sucursal/${selectedId}`;
        const response = await fetch(zonaUrl, {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.status === 200) {
          const result = await response.json();
          setSelectedZonas("");
          if (result) {
            setZonas(result);
          }
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchEventos = async (selectedId) => {
    try {
      if (selectedId) {
        let eveUrl = `${config.api.baseURL}/eventos/empresa/${selectedId}`;
        const response = await fetch(eveUrl, {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.status === 200) {
          const result = await response.json();
          setSelectedEventos("");
          if (result) {
            setEventos(result);
          }
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleEmpresasChange = (e) => {
    const selectedId = e.target.value;
    setSelectedEmpresas(selectedId);
    fetchSucursales(selectedId);
    fetchEventos(selectedId);
  };

  const handleSucursalesChange = (e) => {
    const selectedId = e.target.value;
    setSelectedSucursales(selectedId);
    fetchZonas(selectedId);
  };

  const handleEventosChange = (e) => {
    const selectedId = e.target.value;
    setSelectedEventos(selectedId);
  };

  const controlsDisabled = isLoadingData || isDownloading
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <MDButton
              variant="outlined"
              color="success"
              size="small"
              onClick={toggleFilters}
              sx={{ mb: 2 }}
            >
              {filtersOpen ? "Ocultar filtros" : "Mostrar filtros"}
            </MDButton>
            <Collapse in={filtersOpen} timeout="auto" unmountOnExit>
              <Card sx={{ p: 2, mb: 3 }}>
                <MDTypography variant="h6" color="text" gutterBottom>
                  Filtros
                </MDTypography>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl fullWidth>
                      <InputLabel>Empresa</InputLabel>
                      <Select
                        label="Empresa"
                        variant="outlined"
                        fullWidth
                        value={selectedEmpresas}
                        onChange={handleEmpresasChange}
                        sx={{ p: 1.5 }}
                        placeholder="Seleccione.."
                      >
                        <MenuItem value="">Ninguna</MenuItem>
                        {empresas.map((emp) => (
                          <MenuItem key={emp.idEmpresa} value={emp.idEmpresa}>
                            {emp.descripcion}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl fullWidth>
                      <InputLabel>Sucursal</InputLabel>
                      <Select
                        label="Sucursal"
                        variant="outlined"
                        fullWidth
                        value={selectedSucursales}
                        onChange={handleSucursalesChange}
                        sx={{ p: 1.5 }}
                        placeholder="Seleccione.."
                      >
                        <MenuItem value="">Ninguna</MenuItem>
                        {sucursales?.map((sucu) => (
                          <MenuItem key={sucu.idSucursal} value={sucu.idSucursal}>
                            {sucu.descripcion}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl fullWidth>
                      <InputLabel>Evento</InputLabel>
                      <Select
                        label="Evento"
                        variant="outlined"
                        fullWidth
                        value={selectedEventos}
                        onChange={handleEventosChange}
                        sx={{ p: 1.5 }}
                        placeholder="Seleccione.."
                      >
                        <MenuItem value="">Ninguna</MenuItem>
                        {eventos?.map((sucu) => (
                          <MenuItem key={sucu.idEvento} value={sucu.idEvento}>
                            {sucu.descripcion}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl fullWidth>
                      <InputLabel>Zonas</InputLabel>
                      <Select
                        label="Zona"
                        variant="outlined"
                        fullWidth
                        value={selectedZonas}
                        onChange={(e) => setSelectedZonas(e.target.value)}
                        sx={{ p: 1.5 }}
                        placeholder="Seleccione.."
                      >
                        <MenuItem value="">Ninguna</MenuItem>
                        {zonas?.map((z) => (
                          <MenuItem key={z.idZona} value={z.idZona}>
                            {z.descripcion}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <TextField
                      label="Nombre/Apellido"
                      variant="outlined"
                      fullWidth
                      value={nombreTerm}
                      onChange={handleNombreSearch}
                      onKeyDown={(event) => {
                        if (event.key === "Enter") {
                          handleNombreSearch(event);
                        }
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl fullWidth>
                      <InputLabel>Tipo de Documento</InputLabel>
                      <Select
                        label="Tipo de Documento"
                        variant="outlined"
                        fullWidth
                        value={selectedTipoDoc}
                        onChange={(e) => setSelectedTipoDoc(e.target.value)}
                        sx={{ p: 1.5 }}
                        placeholder="Seleccione.."
                      >
                        <MenuItem value="">Ninguno</MenuItem>
                        <MenuItem key="CIP" value="CIP">CIP</MenuItem>
                        <MenuItem key="DNI" value="DNI">DNI</MenuItem>
                        <MenuItem key="PAS" value="PAS">PAS</MenuItem>
                        <MenuItem key="CPF" value="CPF">CPF</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <TextField
                      label="Nro. de Documento"
                      variant="outlined"
                      fullWidth
                      value={docNro}
                      onChange={handleNroDocSearch}
                      onKeyDown={(event) => {
                        if (event.key === "Enter") {
                          handleNroDocSearch(event);
                        }
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <TextField
                      label="IP equipo"
                      variant="outlined"
                      fullWidth
                      value={ipEquipo}
                      onChange={handleIpEquipoSearch}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <TextField
                      label="Nombre de dispositivo"
                      variant="outlined"
                      fullWidth
                      value={nombreDispositivo}
                      onChange={handleNombreDispositivoSearch}
                      onKeyDown={(event) => {
                        if (event.key === "Enter") {
                          handleNombreDispositivoSearch(event);
                        }
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl fullWidth>
                      <InputLabel>No Identificados</InputLabel>
                      <Select
                        label="No Identificados"
                        variant="outlined"
                        fullWidth
                        value={noIdentificados}
                        onChange={(e) => setNoIdentificados(e.target.value)}
                        sx={{ p: 1.5 }}
                        placeholder="Seleccione.."
                      >
                        <MenuItem value="">Default</MenuItem>
                        <MenuItem key="1" value={true}>Incluir</MenuItem>
                        <MenuItem key="0" value={false}>Excluir</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl fullWidth>
                      <InputLabel>Duplicados</InputLabel>
                      <Select
                        label="Duplicados"
                        variant="outlined"
                        fullWidth
                        value={duplicados}
                        onChange={(e) => setDuplicados(e.target.value)}
                        sx={{ p: 1.5 }}
                        placeholder="Seleccione.."
                      >
                        <MenuItem value="">Default</MenuItem>
                        <MenuItem key="1" value={true}>Incluir</MenuItem>
                        <MenuItem key="0" value={false}>Excluir</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl fullWidth>
                      <InputLabel>¿Multiples coincidencias?</InputLabel>
                      <Select
                        label="¿Multiples coincidencias?"
                        variant="outlined"
                        fullWidth
                        value={multiplesCoincidencias}
                        onChange={(e) => setMultiplesCoincidencias(e.target.value)}
                        sx={{ p: 1.5 }}
                        placeholder="Seleccione.."
                      >
                        <MenuItem value="">Default</MenuItem>
                        <MenuItem key="1" value={true}>Si</MenuItem>
                        <MenuItem key="0" value={false}>No</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <Flatpickr
                      value={fechaDesde}
                      options={{
                        locale: "es",
                        enableTime: true,
                        time_24hr: true,
                        defaultHour: new Date().getHours(), // Set default hour to the current hour
                        defaultMinute: new Date().getMinutes(), // Set default minute to the current minute
                      }}
                      onChange={(date) => {
                        setFechaDesde(date[0]);
                      }}
                      render={({ defaultValue, value, ...props }, ref) => (
                        <TextField
                          fullWidth
                          label="Fecha Desde"
                          variant="outlined"
                          value={fechaDesde ? fechaDesde.toLocaleString() : ""}
                          inputRef={ref}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <Flatpickr
                      value={fechaHasta}
                      options={{
                        locale: "es",
                        enableTime: true,
                        time_24hr: true,
                        defaultHour: new Date().getHours(), // Set default hour to the current hour
                        defaultMinute: new Date().getMinutes(), // Set default minute to the current minute
                      }}
                      onChange={(date) => {
                        setFechaHastaTerm(date[0]);
                      }}
                      render={({ defaultValue, value, ...props }, ref) => (
                        <TextField
                          fullWidth
                          label="Fecha Hasta"
                          variant="outlined"
                          value={fechaHasta ? fechaHasta.toLocaleString() : ""}
                          inputRef={ref}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={12}>
                    <MDButton color="info" variant="gradient" onClick={handleSearch}>
                      Buscar
                    </MDButton>
                    &nbsp;
                    <MDButton color="info" variant="outlined" onClick={handleClearFilters}>
                      Limpiar
                    </MDButton>
                    &nbsp;
                    <MDButton
                      color="success"
                      variant="outlined"
                      onClick={openDownloadMenu}
                      endIcon={isDownloading ? <CircularProgress size={20} /> : <Icon>file_download</Icon>}
                      disabled={isDownloading}
                    >
                      {isDownloading ? "Generando..." : "Descargar"}
                    </MDButton>
                    <Menu anchorEl={downloadAnchorEl} open={downloadMenuOpen} onClose={closeDownloadMenu}>
                      <MenuItem onClick={() => { closeDownloadMenu(); openNameDialog("XLSX") }}>Excel</MenuItem>
                      <MenuItem onClick={() => { closeDownloadMenu(); openNameDialog("PDF") }}>PDF</MenuItem>
                    </Menu>
                  </Grid>
                </Grid>
              </Card>
            </Collapse>
            <MDBox pt={3}>
              <Card>
                <MDBox px={3} pt={2} pb={1} display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={1}>
                  <MDTypography variant="button" fontWeight="regular">
                    Total: {new Intl.NumberFormat("es-PY").format(totalCount)} registros
                  </MDTypography>
                  <MDTypography variant="caption" color="text">
                    Mostrando {new Intl.NumberFormat("es-PY").format(rows.length)}
                  </MDTypography>
                </MDBox>
                {rows.length === 0 && !isLoadingData ? (
                  <MDBox py={6} display="flex" justifyContent="center">
                    <MDTypography variant="body2" color="text">Sin datos</MDTypography>
                  </MDBox>
                ) : (
                  <DataTable
                    table={{ columns, rows: rows }}
                    isSorted={false}
                    noEndBorder
                    showTotalEntries={false}
                    entriesPerPage={false}
                    canSearch={false}
                    pagination={false}
                  />
                )}
                <MDBox pb={3} pt={3} px={3} display="flex" justifyContent="center">
                  {hasMore && (
                    <MDButton
                      color="info"
                      variant="outlined"
                      onClick={handleLoadMore}
                      disabled={controlsDisabled}
                    >
                      {isLoadingData ? "Cargando..." : "Cargar más"}
                    </MDButton>
                  )}
                </MDBox>
              </Card>
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
      <Dialog PaperProps={{
        style: dialogStyle,
      }} open={nameDialogOpen} onClose={closeNameDialog} fullWidth maxWidth="xs">
        <DialogTitle>Nombre del archivo ({pendingFormat})</DialogTitle>
        <DialogContent>
          <Tooltip title={FILE_NAME_HELP_TEXT} placement="top">
            <span style={{ display: "block" }}>
              <TextField
                autoFocus
                margin="dense"
                label="Nombre"
                type="text"
                fullWidth
                value={fileName}
                onChange={(e) => setFileName(sanitizeFileName(e.target.value))}
                placeholder={`reporte_${pendingFormat.toLowerCase()}`}
              />
            </span>
          </Tooltip>
        </DialogContent>
        <DialogActions>
          <MDButton onClick={closeNameDialog} color="secondary" variant="outlined">Cancelar</MDButton>
          <MDButton onClick={confirmDownload} color="success" variant="gradient">Confirmar</MDButton>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
}

export default Liveness;
